var App = App || {};
App.blog = {
	search_tm: null,
	init: function () {
		console.log('init App blog');
		this.addCta();
		this.watch();
	},
	addCta: function () {
		let news = $('div#news');
		let article = news.find('div.page_content[itemprop="articleBody"]');
		let pm = news.find('ul.tree li:last a').attr('href');
		let if_pm = pm && pm.includes('/pm-solutions/');
		if (article.length && if_pm) {
			let h2 = article.find('h2, h3, h4').first();
			let cta = '<div style="width: 100%; text-align: center; padding: 32px 0;"><ws-btn name="btn btn-a btn-cta" class="textImage__button" text="'+localize.try_free+'" right-icon="chevron_sm-right" right-icon-data-sprite="arrows" onclick="App.auth.show();"></ws-btn></div>';
			if (h2.length) h2.before(cta);
		}
	},
	show: function () {
		window.lastScrolltop = $(window).scrollTop();
		if ($(window).width() < 992) $(window).scrollTop(0);
		else if ($('body').attr('data-home') && !$('body').hasClass('page-home')) {
			document.location.href = $('body').attr('data-home');
			return false;
		}
		// if (1) { //$(window).width() > 992) {
		// 	$('body').addClass('bd_menu bd_catalog');
		// 	$('#catalog').appendTo('body').removeClass('hide').show().find('.footer_copy').html($('#footer-dark').html());
		// 	$('.langSwitcher__select').off('change', langSwitcherSelect);
		// 	$('.langSwitcher__select').on('change', langSwitcherSelect);
			// } else {
			//     $(window).scrollTop(0);
			//     $('body').addClass('bd_search').removeClass('bd_search');
			//     $('#catalog .tags.tags_').hide();
			//     $('#catalog .button-more').hide();
			//     $('#catalog .results').hide();
			//     $('#catalog').find('#footer-dark').remove();
			//     $('#catalog').append('<div id="footer-dark">' + $('#footer-dark').html() + '</div>').show();
		// }
	},
	addTag: function (item) {
		const tag = $(item).data('name');
		const tags = $('#tags');

		let tagList = tags.val().split(',');

		tagList = tagList.map((el) => {return el.trim()});
		tagList = tagList.filter((el) => {return el.length > 0});

		if (!tagList.includes(tag)) {
			tagList.push(tag);
		}

		tags.val(tagList.join(', '));
	},
	updateTags: function (form) {
		const _form = $(form);
		const _url = window.location.pathname.split("/").slice(0, -1).join("/") + '/updatetags';

		$.ajax({
			url: _url,
			dataType: "json",
			type: "POST",
			data: _form.serialize(),

			beforeSend: function() { // Не даем несколько раз нажать кнопку
				_form.find("button[type=submit]").attr('disabled','disabled');
			},
			success: function(res) {
				if (res.status) {
					$('#tags_').replaceWith(res.tagsOnTop);
					$('#bottomTags').html(res.tagsOnBottom);
				} else {
					alert(res.message);
				}
			},
			complete: function () {
				_form.find("button[type=submit]").removeAttr('disabled');
			}
		});

		return false;
	},
	addComment: function(form) {
		const _form = $(form);
		const _url = window.location.pathname.split("/").slice(0, -1).join("/") + '/addcomment';

		if (_form.hasClass('frm_sent')) {
			return false;
		}

		// Комментарий
		if (!form.rdescr.value) {
			$(form.rdescr).blink();
			return false;
		}

		// Имя
		if (!form.rname.value) {
			$(form.rname).blink();
			return false;
		}

		_form.addClass('frm_sent');

		$.ajax({
			url: _url,
			dataType: "json",
			type: "POST",
			data: _form.serialize(),

			beforeSend: function() { // Не даем несколько раз нажать кнопку
				_form.find("button[type=submit]").attr('disabled','disabled');
			},
			success: function(res) {
				if (res.status) {
					$('#com' + _form.find('input[name="id"]').val()).html(res.content);
					_form.find('textarea[name="rdescr"]').val('');
				} else {
					alert(res.message);
				}
			},
			complete: function () {
				_form.removeClass('frm_sent');
				_form.find("button[type=submit]").removeAttr('disabled');
			}
		});

		return false;
	},
	watch: function () {
		$('#catalog .button-more').click(function () {
			$('#catalog .button-more').addClass('hidden');
			$('#catalog .tags.tags_').addClass('tags-view-all');
		});

		$(document).on('click', '.js_addTag', function () {
			App.blog.addTag(this);
			return false;
		});

		$(document).on('submit', '#tags_edit form', function () {
			App.blog.updateTags(this);
			return false;
		});

		$(document).on('submit', 'form.js_addComment', function () {
			App.blog.addComment(this);
			return false;
		});

		$(document).on('click', '#tags_ span.edit', function () {
			$('#tags_edit').toggle();
		});

		// $('.search a:first').click(function () {
		//     App.blog.resetTagBlock();
		// });

		// $('#header, #header2').click(function (e) {
		// 	if (!$(e.target).parents().addBack().filter('a').length) {
		// 		$('html,body').stop().animate({scrollTop: 0}, 500, 'swing');
		// 	}
		// });

		$('#catalog .results').on('click', '#resset_search', function (e) {
			App.blog.resetSearch();
		});

		$('#catalog .reset-input').click(function () {
			App.blog.resetSearch();
		});

		$('#catalog .close-search').click(function () {
			$('body').removeClass('bd_catalog');
			if ($(window).width() < 992) {
				$(window).scrollTop(window.lastScrolltop);
				$('body').removeClass('bd_search bd_menu');
			} else {
				setTimeout(function () {
					$('body').removeClass('bd_search bd_menu');
				}, 500);
			}
			$('#catalog .button-more').removeClass('hidden');
			$('#catalog .tags.tags_').removeClass('tags-view-all');
			// window.setTimeout(function () {
			//     $('#header').removeClass('header_alt2');
			// }, 300);
		});

		$('#catalog .search-block .input').keyup(function () {
			var key = $('#catalog .search-block .input').val();
			if (key === '') {
				$('#catalog .search-block .input').css({'font-style': 'italic', 'color': '#777'});
			} else {
				$('#catalog .search-block .input').css({'font-style': 'normal', 'color': '#000'});
			}
			if (App.blog.search_tm) window.clearTimeout(App.blog.search_tm);
			App.blog.search_tm = window.setTimeout(App.blog.seacrh, 500);
			$('#catalog .reset-input').addClass('visible');
		});

		$('#catalog .search-block form').submit(function () {
			return false;
		});

		$('#copy_link').click(function () {
			//App.blog.copyLink(this);
			if ($(this).hasClass('copy_hash')) {
				clipboard(document.location.toString());
			} else {
				clipboard(document.location.toString().replace(/#.*/, ''));
			}
			$('#copy_link').html('<svg viewBox="0 0 20 20"><polyline points="4 11 8 15 16 6"></polyline></svg>');
			$('#copy_link').css({'padding': '13px', 'width': '46px'});
			setTimeout(function () {
				$('.drophead .esc').click();
				setTimeout(function () {
					$('#copy_link').css({'padding': '13px 25px', 'width': '190px'});
				}, 1000);
			}, 1000);
		});

		$('#catalog .link-close a').click(function () {
			$('#catalog').find('#footer-dark').remove();
		});

		$('#catalog .search_area, #catalog .tags a.more').click(function () {
			$('#button_search').click();
			$('#catalog').find('#footer-dark').remove();
			$('#catalog').find('.input').trigger('focus');
			return false;
		});

		$('body').on('click', '.h-close, #catalog_overlay', function () {
			//$('body').find('#top_menu').addClass('hide');
			$('body').removeClass('bd_catalog');
			if ($(window).width() < 992) $(window).scrollTop(window.lastScrolltop);
			setTimeout(function () {
				$('body').removeClass('bd_search bd_menu');
			}, 500);
		});

		$(window).on('scroll', function () {
			if (document.body.scrollHeight > $(window).height()) {
				var width = Math.round(100 * ($(window).scrollTop() / $('#news').height()));// $('#news').height() - $(window).height()
				var height = (width > 100) ? 0 : 2;
				$('#header .progress div').show().css({
					width: width + '%',
					height: height + 'px'
				});
			}
		});

		$('#button_search').click(function () {
			if ($(window).width() < 992) $('#catalog').appendTo('body').removeClass('hide').show().find('.footer_copy').html($('#footer-dark').html());
			App.blog.resetSearch();
			$('body').addClass('bd_search bd_catalog').removeClass('bd_menu');
			window.lastScrolltop = $(window).scrollTop();
			if ($(window).width() < 992) $(window).scrollTop(0);
			$('#catalog').show().find('.input').trigger('focus');
			return false;
		});
		// mobileMenu.click(function () {
		//     $('body').addClass('bd_search');
		//     return false;
		// });
	},

	seacrh: function () {
		var key = $('#catalog .search-block .input').val();
		$('#catalog .results').css({height: $('#catalog .results').height()});
		if (key.length >= 2) {
			let url = '/api/user/';
			let data = 'action=blog_autocomplete&';
			if ($('body').hasClass('bd_lang4')) {
				data += 'do_lang=4&';
			}
			if ($('body').hasClass('bd_lang2')) {
				data += 'do_lang=2&';
			}
			data += 'q=' + encodeURIComponent($('#catalog .search-block .input').val());
			$.ajax({
				type: "GET",
				url: url,
				data: data,
				success: function (responsed) {
					$('#catalog .results').html(responsed);
				}
			}).done(function () {
				$('#catalog .results').css({
					height:
						($('#catalog .results .in').outerHeight() || 0) +
						($('#catalog .results .tags').outerHeight() || 0) +
						($('#catalog .results .empty').outerHeight() || 0)
				});
			});
			$('#catalog').addClass('wresult');
		} else {
			//$('#catalog .results .in').css({'max-height': '20vh'});
			$('#catalog').removeClass('wresult');
		}
	},

	resetSearch: function () {
		$('#catalog').removeClass('wresult');
		$('#catalog .search-block .input').val('').css('font-style', 'italic').focus();
		$('#catalog .tags.tags_').removeClass('tags-view-all');
		$('#catalog .button-more').removeClass('hidden');
		$('#catalog .reset-input').removeClass('visible');
		// $('#catalog .search-block').show();
	},

	copyLink: function (el) {
		var aux = document.createElement("input");
		$(aux).css({
			position: 'absolute',
			'opacity': 0
		}).val(document.location.toString().replace(/#.*/, '')).insertAfter(el).select();
		document.execCommand("copy");
		$(aux).remove();
	},

	resetTagBlock: function () {
		$('#catalog .button-more').removeClass('hidden');
		$('#catalog .tags.tags_').removeClass('tags-view-all');
	}
};

$(document).ready(function () {
	App.blog.init();
});